<template>
  <v-dialog max-width="450px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Offer Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-2">
          <v-col cols="12" sm="12" md="12">
            <r-item-offer-dropdown :model.sync="model.offer" label="Select Offer" :clearable="true"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model.number="model.mergeLength"
                    v-on="on"
                    v-bind="attrs"
                    label="Merge Length"
                    hide-details
                />
              </template>
              <dl>
                <dt> 0: Disabled</dt>
                <dt> n: The length of the merge must be greater than or equal to {N}</dt>
              </dl>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row dense class="mt-2">
          <r-rarity-items :items.sync="model.rarity" title="Rarity"/>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemOfferConfig} from "@/modules/redactor/models/item/offer/ItemOfferConfig";
import RRarityItems from "@/modules/redactor/views/rarity/r-rarity-items.vue";
import RItemOfferDropdown from "@/modules/redactor/views/item-offer/r-item-offer-dropdown.vue";

export default {
  name: "r-item-offer-config",
  components: {RItemOfferDropdown, RRarityItems},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemOfferConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemOfferConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>